import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { Button } from '../button/button.component';

export interface IInfoModalProps {
  dismissTitle?: string;
  message?: string;
  open?: boolean;
  title?: string;
  onClose: () => void;
}

export const InfoModal = ({
  dismissTitle = 'Got it',
  message,
  open,
  title = 'Information',
  onClose
}: IInfoModalProps) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 text-center">
                  {title}
                </Dialog.Title>
                {!!message && (
                  <div className="mt-4">
                    <p className="text-sm text-gray-700 whitespace-pre-line">{message}</p>
                  </div>
                )}

                <div className="flex justify-center mt-6">
                  <Button text={dismissTitle} onClick={onClose} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
